import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import { Button, Card, Form, Input, notification } from "antd";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
function UpdatecontactInformation() {
  const [form] = Form.useForm();
  // const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        contactNumber: values.contactNumber,
        customer_care_number: values.customer_care_number,
        faceBookLink: values.faceBookLink,
        instaLink: values.instaLink,
        youtubeLink: values.youtubeLink,
        email: values.email,
        address: values.address,
        Whatsapp: values.Whatsapp,
      };

      setIsLoading(true);
      let api = API.EDIT_CONTACT_INFORMATION + id;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({
          message: "contact infromation updated successfully!",
        });
        form.resetFields();
        fetchonecontactinformation();
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchonecontactinformation = async () => {
    try {
      setIsLoading(true);
      let api = API.FIND_ONE_CONTACT_INFORMATION + id;
      const response: any = await GET(api, {});
      // setData(response?.data);
      form.setFieldsValue(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchonecontactinformation();
  }, []);

  return (
    <div>
      <h1>Update Contact Infromation Page</h1>
      <Card>
        <Form form={form} onFinish={UpdateHandler} layout="vertical">
          <Form.Item
            name="contactNumber"
            label="contactNumber"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="customer_care_number"
            label="customer_care_number"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="faceBookLink"
            label="faceBookLink"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="instaLink"
            label="instaLink"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="youtubeLink"
            label="youtubeLink"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="email" label="email" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="address"
            label="address"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="Whatsapp"
            label="Whatsapp"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  );
}

export default UpdatecontactInformation;
